export enum groupTabs {
  ABTeam = 'AB Team',
  AccountManagers = 'Account Managers',
  All = 'All',
  Blitz = 'Blitz',
  ClearWord = 'ClearWord',
  NOVA = 'NOVA',
  POD = 'POD',
  Sunrise = 'Sunrise',
  TechTeam = 'Tech Team',
}
